import React from "react";
import { useNavigate } from "react-router-dom";
import Sivutus from "./Sivutus";

import ryhmat from "./json/ryhmat";
import fryhmat from "./json/fryhmat";

const Ryhmat = (props) => {
  const { tila, asetatila } = props;
  const navigate = useNavigate();

  function handleClick(event) {
    asetatila("haku", { ryhmä: event.target.id });
    navigate("/");
  }
  const r = tila.frisbee ? fryhmat : ryhmat;
  const html = r.map((element) => {
    const checked = tila.haku.ryhmä === element.id;
    if (element.ryhmaOtsikko)
      return (
        <span className={element.id} id={element.id} key={element.id}>
          {element.ryhmaOtsikko}:
        </span>
      );
    return (
      <div className={element.id} key={element.id}>
        {element.ryhmaOtsikko && (
          <span className="ryhma__otsikko">{element.ryhmaOtsikko}:</span>
        )}
        <label className="radiot linkki" onClick={handleClick}>
          <img
            src={"/frisbeeapuri/" + element.src}
            alt="Kuva"
            className="minikuva minikuva--pyorea"
          />
          {/* <img src={kuva} alt="Kuva" className="minikuva minikuva--pyorea" /> */}
          <input
            className="link"
            type="radio"
            name="tyyppi"
            id={element.id}
            defaultChecked={checked}
          ></input>
          <label className="tyyli" htmlFor={element.id}>
            {element.teksti}
          </label>
          <span className="omaRadio linkki"></span>
        </label>
      </div>
    );
  });
  return (
    <div>
      <form>
        <div className="ryhmat">{html}</div>
      </form>
      <br />
      <div className="martop">
        Sivu:
        <Sivutus tila={tila} asetatila={asetatila} />
      </div>
    </div>
  );
};

export default Ryhmat;
